import JsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import handlebars from 'handlebars/dist/handlebars'

import logoAnfr from '@/assets/img/logo-anfr.png'
import store from '@/store'

let mapLegendFrTpl = handlebars.compile(`
<div><div class="cr-pt-legend {{format}}">

  {{#if supports.show}}
  <div class="cr-pt-legend-layers">
    <h1>Supports</h1>

    {{#if supports.tm.show}}
    <img style='height:20px;' src='/static/img/supports/SUP_1_BFOS.png'/> <span>Téléphonie mobile :</span>
    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    {{#if supports.tm.active}}
    Stations en service
    {{else}}
    Tous les sites
    {{/if}}
    {{#each supports.tm.technologies}}
    {{#if @last}} {{#unless @first}} et {{/unless}}{{/if}}
    {{this}}
    {{/each}} des opérateurs
    {{#each supports.tm.operateurs}}
    {{#if @last}} {{#unless @first}} et {{/unless}}{{/if}}
    {{#if display}}<span>{{display}}</span>{{/if}} <img style='height:20px;' src='{{icon}}'/>
    {{/each}}
    {{/if}}

    {{#if supports.tv.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_2.png'/> <span>TV</span>
    {{/if}}

    {{#if supports.radio.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_4.png'/> <span>Radio FM</span>
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_7.png'/> <span>Radio AM</span>
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_8.png'/> <span>Radio RNT</span>
    {{/if}}

    {{#if supports.autre.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_3.png'/> <span>Autres stations</span>
    {{/if}}

    {{#if supports.pmr.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_6.png'/> <span>Réseaux mobiles privés</span>
    {{/if}}

    {{#if supports.fh.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_5.png'/> <span>Faisceaux hertziens</span>
    {{/if}}
  </div>
  {{/if}}

  {{#if mesures.show}}
  <div class="cr-pt-legend-layers">
    <h1>Mesures</h1>
    <p><img class='cr-legend-supp-logo' src='/static/img/mesures/MES_X.png'/><span>Mesures de moins de {{mesures.anciennete}} jours entre {{mesures.niveauMin}} et {{mesures.niveauMax}} V/M</span></p>
    {{#if mesures.objets}}
    <p><img class='cr-legend-supp-logo' src='/static/img/mesures/OBJ_X.png'/><span>Objets communicants</span></p>
    {{/if}}
  </div>
  {{/if}}

  {{#if simulations.pnse}}
    {{#if simulations.show}}
      <div class="cr-pt-legend-layers">
        <h1>Simulations</h1>
        {{#if simulations.sol.show}}
        <p><img class='cr-legend-supp-logo' src='/static/img/simulations/simulations_legende_small.png'/><span>Sol</span></p>
        {{/if}}
      </div>
    {{/if}}
  {{/if}}

  <div class="cr-pt-infodiv">
    <div class="cr-pt-date">Edition du {{date}}</div>
  </div>
  <br/>
  <div class="cr-pt-footer">
  L'Agence nationale des fréquences ne saurait garantir l'exhaustivité et l'exactitude des informations fournies, celles-ci étant, dans la plupart des cas, collectées auprès de personnes tierces (exploitants, laboratoires de mesures, ...).
  </div>
</div></div>
`)

let mapLegendEnTpl = handlebars.compile(`
<div><div class="cr-pt-legend {{format}}">

  {{#if supports.show}}
  <div class="cr-pt-legend-layers">
    <h1>Supports</h1>

    {{#if supports.tm.show}}
    <img style='height:20px;' src='/static/img/supports/SUP_1_BFOS.png'/> <span>Mobile telephony :</span>
    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    {{#if supports.tm.active}}
    Active stations
    {{else}}
    All stations
    {{/if}}
    {{#each supports.tm.technologies}}
    {{#if @last}} {{#unless @first}} and {{/unless}}{{/if}}
    {{this}}
    {{/each}} of operators
    {{#each supports.tm.operateurs}}
    {{#if @last}} {{#unless @first}} and {{/unless}}{{/if}}
    {{#if display}}<span>{{display}}</span>{{/if}} <img style='height:20px;' src='{{icon}}'/>
    {{/each}}
    {{/if}}

    {{#if supports.tv.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_2.png'/> <span>TV</span>
    {{/if}}

    {{#if supports.radio.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_4.png'/> <span>FM Radio</span>
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_7.png'/> <span>AM Radio</span>
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_8.png'/> <span>Digital Radio</span>
    {{/if}}

    {{#if supports.autre.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_3.png'/> <span>Other stations</span>
    {{/if}}

    {{#if supports.pmr.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_6.png'/> <span>Private mobile networks</span>
    {{/if}}

    {{#if supports.fh.show}}
    <br/>
    <img style='height:20px;' src='/static/img/supports/SUP_5.png'/> <span>Hertzian beam</span>
    {{/if}}
  </div>
  {{/if}}

  {{#if mesures.show}}
  <div class="cr-pt-legend-layers">
    <h1>Mesures</h1>
    <p><img class='cr-legend-supp-logo' src='/static/img/mesures/MES_X.png'/><span>Measures over {{mesures.anciennete}} days between {{mesures.niveauMin}} and {{mesures.niveauMax}} V/M</span></p>
  </div>
  {{/if}}

  {{#if simulations.pnse}}
    {{#if simulations.show}}
      <div class="cr-pt-legend-layers">
        <h1>Simulations</h1>
        {{#if simulations.sol.show}}
        <p><img class='cr-legend-supp-logo' src='/static/img/simulations/simulations_legende_small.png'/><span>ground</span></p>
        {{/if}}
      </div>
    {{/if}}
  {{/if}}

  <div class="cr-pt-infodiv">
    <div class="cr-pt-date">Edition of {{date}}</div>
  </div>
  <br/>
  <div class="cr-pt-footer">

The National Frequency Agency can not guarantee the completeness and accuracy of the information provided, which is, in most cases, collected from third parties (operators, measurement laboratories, etc.).
  </div>
</div></div>
`)

class MapPrinter {
  map = null
  english = null

  olCanvas = null
  ignSource = null

  resolution = 150 /* en dpi */
  // format = 'a3', imagedim = [297, /*420*/300]
  format = 'a4'
  imagedim = [210, /* 297 */ 140]

  // 1 Inch = 25.4 mm
  width = Math.round(this.imagedim[0] * this.resolution / 25.4)
  height = Math.round((this.imagedim[1]) * this.resolution / 25.4)

  savedSize = null
  savedExtent = null

  timeoutListener = null
  timeout = 30000
  startTimeoutListener = null
  startTimeout = 1000
  loading = 0
  loaded = 0

  constructor(map) {
    this.map = map
  }

  execute() {
    // Récupération de la locale dans execute pour être plus dynamique
    this.english = window.vm.$root.$i18n.locale === 'en'

    this.olCanvas = null
    this.ignSource = null
    this.loading = this.loaded = 0
    this.loaded = 0

    // Impression du canvas de la carte réalisée après le rendu (une seule écoute)
    this.map.once('postcompose', this.afterPostcompose, this)

    this.guiStart()
    this.saveMapDimensions()
    this.changeMapDimensions()
    this.map.renderSync()
  }

  afterPostcompose(event) {
    console.debug('MapPrinter', 'Après rendu de la carte (postcompose)')
    // Sauvegarde du canvas
    this.olCanvas = event.context.canvas

    let currentIgnLayer = window.vm.$store.state.ign
    var ignLayer = null
    this.map.getLayers().forEach(layer => {
      if (layer.get('layerName') === currentIgnLayer) {
        ignLayer = layer
        return false
      }
    })
    this.ignSource = ignLayer.getSource()
    this.startTileListening()
  }

  startTileListening() {
    console.debug('MapPrinter', 'Mise en place des écoutes')
    this.ignSource.on('tileloadstart', this.tileLoadStart, this)
    this.ignSource.on('tileloadend', this.tileLoadEnd, this)
    this.ignSource.on('tileloaderror', this.tileLoadEnd, this)
    // On a deux mécanismes de sécurité :
    // -1- après un délai court, on vérifie qu'au moins une dalle est demandée (possible que ça ne soit pas le cas)
    // -2- après un délai plus long, on génère même si on n'a pas reçu toutes les dalles
    this.startTimeoutListener = window.setTimeout(() => this.onStartTimeout(), this.startTimeout)
    this.timeoutListener = window.setTimeout(() => this.onTimeout(), this.timeout)
  }
  stopTileListening() {
    console.debug('MapPrinter', 'Arrêt des écoutes')
    // Les générations "de sécurité" n'ont plus lieu d'être
    window.clearTimeout(this.startTimeoutListener)
    window.clearTimeout(this.timeoutListener)
    this.ignSource.un('tileloadstart', this.tileLoadStart, this)
    this.ignSource.un('tileloadend', this.tileLoadEnd, this)
    this.ignSource.un('tileloaderror', this.tileLoadEnd, this)
  }
  tileLoadStart() {
    ++this.loading
    console.debug('MapPrinter', 'Une dalle demandée (' + this.loaded + ' / ' + this.loading + ')')
  }
  tileLoadEnd() {
    ++this.loaded
    console.debug('MapPrinter', 'Une dalle arrivée (' + this.loaded + ' / ' + this.loading + ')')
    if (this.loading === this.loaded) {
      this.stopTileListening()
      // Terminé, on génère le pdf
      console.debug('MapPrinter', 'Toutes les dalles sont arrivées (' + this.loaded + ')')
      window.setTimeout(() => this.generatePdf(this.olCanvas), 100)
    }
  }

  onStartTimeout() {
    if (this.loading < 1) {
      console.debug('MapPrinter', 'Aucune dalle demandée')
      // Sans doute aucune dalle demandée => on génère
      this.generatePdf(this.olCanvas)
    }
  }
  onTimeout() {
    console.debug('MapPrinter', 'Délai dépassé (' + this.timeout + 'ms)')
    // Toutes les dalles IGN ne sont pas arrivées, on imprime quand-même
    this.generatePdf(this.olCanvas)
  }
  generatePdf(olCanvas) {
    console.debug('MapPrinter', 'Génération du pdf')
    this.stopTileListening()

    var pdf = new JsPDF('portrait', undefined, this.format)

    let margin = 20
    pdf.addImage(logoAnfr, 'JPEG', margin, margin, 25, 17)
    pdf.addImage(olCanvas.toDataURL('image/jpeg'), 'JPEG',
      margin, (margin + 17) + 5, this.imagedim[0] - 2 * margin, (this.imagedim[1]) - 2 * margin)

    console.debug('MapPrinter', 'Génération de la légende')
    html2canvas(this.getPreparedLegendElement()).then(legendCanvas => {
      console.debug('MapPrinter', 'Légende générée')
      pdf.addImage(legendCanvas.toDataURL('image/jpeg'), 'JPEG',
        margin, margin + 17 + (5 + this.imagedim[1] - 2 * margin))

      let date = new Date()
      let filename = 'cartoradio' + date.getFullYear() + '' + date.getMonth() + '' + date.getDate() + '' +
        date.getHours() + '' + '' + date.getMinutes() + '' + date.getSeconds() + '' + date.getMilliseconds() + '.pdf'
      console.debug('MapPrinter', 'Sauvegarde du pdf')
      pdf.save(filename)

      this.restoreMapDimensions()
      this.guiStop()
    }).catch((error) => console.debug('MapPrinter', 'Erreur  lors de la génération du pdf', error))
  }

  saveMapDimensions() {
    console.debug('MapPrinter', 'Sauvegarde des dimensions de la carte')
    this.savedSize = this.map.getSize()
    this.savedExtent = this.map.getView().calculateExtent(this.savedSize)
  }
  changeMapDimensions() {
    console.debug('MapPrinter', 'Changement des dimensions de la carte')
    this.map.setSize([this.width, this.height])
    this.map.getView().fit(this.savedExtent, {
      nearest: true
    })
  }
  restoreMapDimensions() {
    console.debug('MapPrinter', 'Restitution des dimensions de la carte')
    this.map.setSize(this.savedSize)
    this.map.getView().fit(this.savedExtent)
    this.map.renderSync()
  }

  getPreparedLegendElement() {
    let div = document.getElementById('printMapContainer')
    if (!div) {
      console.debug('MapPrinter', 'Ajout du conteneur nécessaire à la légende')
      div = document.createElement('div')
      div.style.overflow = 'hidden'
      div.style.position = 'relative'
      div.id = 'printMapContainer'
      document.body.appendChild(div)
    }
    let htmlString = this.english ? mapLegendEnTpl(this.getLegendData()) : mapLegendFrTpl(this.getLegendData())
    div.innerHTML = htmlString.trim()
    let element = div.firstChild
    element.style.position = 'absolute'
    return element
  }

  getLegendData() {
    var operateurs = []
    var technologies = []
    Object.entries(store.state.supports.tm.operateurs).forEach(([key, value]) => {
      if (value.show) {
        let info
        switch (key) {
          case 'BOUYGUES':
            info = {
              icon: '/static/img/operateurs/logo-BOUYGUES_TELECOM.png'
            }
            break
          case 'ORANGE':
            info = {
              icon: '/static/img/operateurs/logo-ORANGE.png'
            }
            break
          case 'SFR':
            info = {
              icon: '/static/img/operateurs/logo-SFR.png'
            }
            break
          case 'FREE':
            info = {
              icon: '/static/img/operateurs/logo-FREE_MOBILE.png'
            }
            break
          case 'AUTRE':
            info = {
              icon: '/static/img/operateurs/logo-outremer.png',
              display: this.english ? 'Overseas operators' : 'd\'Outre Mer'
            }
            break
          default:
            console.log('mapprinter', 'Opérateur inconnu : ' + key + '.')
            return
        }
        operateurs.push(info)
      }
    })
    Object.entries(store.state.supports.tm.technologies).forEach(([key, value]) => {
      if (value.show) {
        technologies.push(key)
      }
    })
    let legendData = {
      format: this.format,
      date: window.vm.$d(new Date(), 'short'),
      supports: {
        show: store.state.supports.show,
        tm: {
          show: store.state.supports.tm.show,
          active: store.state.supports.tm.active === true,
          technologies: technologies,
          operateurs: operateurs
        },
        tv: {
          show: store.state.supports.tv.show
        },
        radio: {
          show: store.state.supports.radio.show
        },
        autre: {
          show: store.state.supports.autre.show
        },
        pmr: {
          show: store.state.supports.mobilenetworks.show
        },
        fh: {
          show: store.state.supports.microwavetransmission.show
        }
      },
      mesures: {
        show: store.state.mesures.show,
        anciennete: store.state.mesures.anciennete,
        niveauMin: store.state.mesures.niveaux[0],
        niveauMax: store.state.mesures.niveaux[1],
        objets: store.state.mesures.objets.show
      },
      simulations: {
        show: store.state.simulations.show,
        sol: store.state.simulations.sol,
        facade: store.state.simulations.facade,
        pnse: store.state.paramUrl.PNSE_ACTIF === 'true'
      }
    }
    console.debug('MapPrinter', 'Données de la légende', legendData)
    return legendData
  }

  guiStart() {
    let vp = this.map.getViewport()
    // On crée un voile au-dessus de la carte avec une opacité pour éviter les interactions
    let printVeil = document.createElement('div')
    printVeil.id = 'printVeil'
    printVeil.style.cssText = 'position:absolute;width:100%;height:100%;top:0;left:0;z-index:99999999;cursor:progress;background-color:#fff;opacity:0.7'
    let info = document.createElement('div')
    info.textContent = window.vm.$t('Génération du fichier en cours. Veuillez patienter...')
    info.style.cssText = 'text-align:center;line-height:' + vp.offsetHeight + 'px;height:' + vp.offsetHeight + 'px;white-space: nowrap'
    printVeil.appendChild(info)
    vp.appendChild(printVeil)
  }
  guiStop() {
    let d = document.getElementById('printVeil')
    d.parentNode.removeChild(d)
  }
}

export default MapPrinter
